export const SCRIPT_ID = 'ze-snippet';
export const DIALOG_ID = '@MY_YOLA/DIALOG/HELP_DIALOG';
export const SOURCE_ID = 'my-yola';
